const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const ExportPDFStatement = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_EXPORT_INVOICE_SAATEMENT_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_EXPORT_INVOICE_SAATEMENT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default ExportPDFStatement;